import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'skeleton-rect',
  styleUrl: '../shine-effect.css',
})
export class SkeletonRect {
  @Prop() width: 'half' | 'full' = 'full';
  @Prop() height: 'xs' | 'sm' | 'md' | 'lg' = 'md';
  @Prop() inverse: boolean = false;
  @Prop() borderRadius: 'rounded-sm' | 'rounded' = 'rounded';

  render() {
    const classes = {
      'shine skeleton-item': true,
      'skeleton-item--inverse': this.inverse,
      'w-full': this.width === 'full',
      'w-1/2': this.width === 'half',
      'h-4': this.height === 'xs',
      'h-5': this.height === 'sm',
      'h-7': this.height === 'md',
      'h-12': this.height === 'lg',
      rounded: this.borderRadius == 'rounded',
      'rounded-sm': this.borderRadius == 'rounded-sm',
    };

    return (
      <Host class="block">
        <div class={classes} />
      </Host>
    );
  }
}
